define('proprietario-resource',['i18n-provider', 'app-route-provider', 'notify-service'], function() {
    var app = angular.module('proprietario.resource', ['i18n.provider', 'app.route.provider', 'notify.service']);
    app.factory('Proprietario', ['$q', '$http', '$location', '$state', 'i18n', 'appRoute', 'notify',
        function($q, $http, $location, $state, i18n, appRoute, notify, $multipart) {
            return {
                applyFilter: function(data) {
                    return $q(function(resolve, reject) {
                        return $http.post(appRoute.linkTo('proprietario.applyFilter'), data).success(function(data) {
                            resolve(data);
                        }).error(function(error) {
                            reject(error);
                        });
                    });
                }
            }
        }
    ]);
});

